import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, HeaderTitle, SubHeaderTitle, ContainerHeader,ContainerTheme, ContainerCol,SubTitle, ContainerRow, SubContainerButton, ContainerImage, ContainerContent, ImageMapa} from './style'
import Button from '../../components/Button/Button'
import ImgEntrada from '../../assets/images/point-flux/entrada.png'
import ImgAlmoco from '../../assets/images/point-flux/almoco.png'
import ImgPoint from '../../assets/images/icon-point.png'
import ImgRetornoAlmoco from '../../assets/images/point-flux/retornoalmoco.png'
import ImgSaida from '../../assets/images/point-flux/saida.png'
import logo from '../../assets/images/logo.png'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { fetchAtualizarSenhaStart, atualizarSenhaReset }  from '../../services/store/reducers/endpoints/atualizarSenha'
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo'
import { pointFlowReset, pointFlowSave }  from '../../services/store/reducers/pointFlow'
import axios from 'axios'
import config from '../../config/configuration'
import GlitchSquiggly from 'react-glitch-effect/core/GlitchSquiggly'
import ModalAlert from '../../components/ModalAlert/ModalAlert'

class PointFlow extends PureComponent{

    state = {
      atual: 0,
      sugerido: 0,
      showModalDuplicado: false,
      tiposDePontos: []
    }

   UNSAFE_componentWillMount () {
    this.props.pointFlowReset()
    
    axios
    .get( config.url + `Ponto/RegisteredPoint?associacao=${this.props.registerPoint.codigoAssociacao}`)
    .then((res) => {
      /**
       * Entrada = mje ou cje
          Saída para o almoço = crs
          Retorno do almoço = cre
          Saída = mjs ou cjs
       */
      /**
       * deixar sugerido o proximo
       * deixar opaco o ultimo
       * 
       */
      this.setState({ tiposDePontos: res.data.tipos })
      console.log('o que temos aqui', res.data)
      if(res.data.tipos.length === 0){
        this.setState({ sugerido: 1 })
      }
      if(res.data.tipos[res.data.tipos.length - 1] === 'cje' || res.data.tipos[res.data.tipos.length - 1] === 'mje'){
        this.setState({ atual: 1, sugerido: 2 })
      }

      if(res.data.tipos[res.data.tipos.length - 1] === 'crs'){
        this.setState({ atual: 2, sugerido: 3 })
      }

      if(res.data.tipos[res.data.tipos.length - 1] === 'cre'){
        this.setState({ atual: 3, sugerido: 4 })
      }

      if(res.data.tipos[res.data.tipos.length - 1] === 'cjs' || res.data.tipos[res.data.tipos.length - 1] === 'mjs'){
        this.setState({ atual: 4, sugerido: 1 })
      }

      console.log('o que está sendo usado?', res.data.tipos[res.data.tipos.length - 1])

    })
    .catch((res) => {
      console.log('um error', res)

        // return false;
    });

    
  }

  voltar(){
    window.location.href = '/register-point'
  }
  
  paraRegisterPoint(tipo){
    this.props.pointFlowSave({
      tipo: tipo
    })

    //window.location.href = '/register-point'
    window.location.href = '/confirmation-point'
  }

  sugeridoRender = () => {
    
    return (
        <GlitchSquiggly disabled={false}>
          <div  style={{ display: 'flex', flexDirection: 'row',alignItems: 'center', marginLeft: -30, marginTop: 0, marginBottom: -30}}>
            <img alt={''} src={ImgPoint} style={{width: 22}}/> <span style={{marginLeft: 10, fontSize: 10, color: '#FFF', fontWeight: 'bold'}}>Sugerido</span>
          </div>
        </GlitchSquiggly>
        
      
    )
  }

  pontoDuplicado = (pontoTipo) => {
    axios
    .get( config.url + `Ponto/registrarPontoDuplicado/${this.props.registerPoint.codigoAssociacao}/${pontoTipo}`)
    .then((res) => {
      console.log('---->', res.data)
      let messageModalDuplicado = ''
      
      switch(pontoTipo) {
        case 'cje':
          messageModalDuplicado = 'Para essa associação o evento de ponto (Entrada da Jornada) esperado já foi registrado!'
          break
        case 'crs':
          messageModalDuplicado = 'Para essa associação o evento de ponto (Saída para Refeição) esperado já foi registrado!'
          break
        case 'cre':
            messageModalDuplicado = 'Para essa associação o evento de ponto (Retorno da Refeição) esperado já foi registrado!'
            break
        case 'cjs':
          messageModalDuplicado = 'Para essa associação o evento de ponto (Saída da Jornada) esperado já foi registrado!'
          break
        default:
          break
      }
      this.setState({
        showModalDuplicado:  true, 
        messageModalDuplicado: messageModalDuplicado
      })
      
    })
    .catch((res) => {
      console.log('um error', res)
      this.setState({
        showModalDuplicado:  true, 
        messageModalDuplicado: 'Não foram encontrados pontos duplicados, por favor entre em contato com o supervisor!'
      })
        // return false;
    });
  }

  render() {

    console.log('registerPoint-->', this.props.registerPoint.codCliente)

    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
        </ContainerImage>
        <CurrentTime></CurrentTime>
        <ContainerHeader>
          <HeaderTitle>Ponto</HeaderTitle>
          <SubHeaderTitle>Selecione seu registro de ponto</SubHeaderTitle>
        </ContainerHeader>

        
        <ContainerContent>
        <ContainerCol>

{/* tipos:
0 = entrada
1 = Saída
2 = retorno Refeição
3 = saída Refeição */}


          <ContainerRow 
            sugerido={this.state.sugerido === 1}
            onClick={() => {
              console.log('this.state.tiposDePontos-->', this.state.tiposDePontos, this.state.tiposDePontos.filter((v) => v === 'cje' || v === 'mje'))
              if(
                this.state.tiposDePontos &&
                this.state.tiposDePontos.length > 0 &&
                this.state.tiposDePontos.filter((v) => v === 'cje' || v === 'mje').length > 0
              ){
                console.log('1****-***')
                this.pontoDuplicado('cje')
              }else{
                console.log('2****-***')
                this.paraRegisterPoint('0')
              }
              /*if(this.state.sugerido === 1 && this.state.atual !== 4){
                this.paraRegisterPoint('0')
              }else{
                this.pontoDuplicado('cje')
              }*/
            }} 
            style={{ backgroundColor: '#3CB371', display: 'flex', flexDirection: 'column', 
                      opacity: 
                       this.state.tiposDePontos &&
                       this.state.tiposDePontos.length > 0 &&
                       this.state.tiposDePontos.filter((v) => v === 'cje' || v === 'mje').length > 0
                         /*this.state.sugerido > 1 || this.state.atual === 4*/
                      ? 0.3 : 1
            }}

          >
            
            <ContainerTheme >
              <SubTitle>Registro de Entrada</SubTitle>
              <ImageMapa marginLeft='4px' src={ImgEntrada} />
            </ContainerTheme>
            { this.state.sugerido === 1 && this.state.atual !== 4 && this.props.registerPoint.codCliente && this.sugeridoRender() }
          </ContainerRow>
          
          
          <ContainerRow 
            sugerido={this.state.sugerido === 2}
            onClick={() => {
              if(
                this.state.tiposDePontos &&
                this.state.tiposDePontos.length > 0 &&
                this.state.tiposDePontos.filter((v) => v === 'crs' || v === 'mrs').length > 0
              ){
                this.pontoDuplicado('crs')
              }else{
                this.paraRegisterPoint('3')
              }
              /*if(this.state.sugerido <= 2 && this.state.atual !== 4){
                this.paraRegisterPoint('3')
              }else{
                this.pontoDuplicado('crs')
              }*/
            }} 
            style={{ backgroundColor: '#FF7F50', display: 'flex', flexDirection: 'column', 
              opacity: 
              this.state.tiposDePontos &&
              this.state.tiposDePontos.length > 0 &&
              this.state.tiposDePontos.filter((v) => v === 'crs' || v === 'mrs').length > 0
              /*this.state.sugerido > 2 || this.state.atual === 4*/
              ? 0.3 : 1}}
          >
          
          <ContainerTheme>
            <SubTitle>Saída para Refeição</SubTitle>
            <ImageMapa src={ImgAlmoco} />
          </ContainerTheme>
          { this.state.sugerido === 2 && this.state.atual !== 4 && this.props.registerPoint.codCliente && this.sugeridoRender() }
        </ContainerRow>
        </ContainerCol>

        <ContainerCol>
        <ContainerRow 
          sugerido={this.state.sugerido === 3 && this.state.atual !== 4}
          onClick={() => {
            if(
              this.state.tiposDePontos &&
              this.state.tiposDePontos.length > 0 &&
              this.state.tiposDePontos.filter((v) => v === 'cre' || v === 'mre').length > 0
            ){
              this.pontoDuplicado('cre')
            }else{
              this.paraRegisterPoint('2')
            }
            /*if(this.state.sugerido <= 3 && this.state.atual !== 4){
              this.paraRegisterPoint('2')
            }else{
              this.pontoDuplicado('cre')
            }*/
          }} 
          style={{ backgroundColor: '#FFD700', display: 'flex', flexDirection: 'column', 
            opacity: 
            this.state.tiposDePontos &&
            this.state.tiposDePontos.length > 0 &&
            this.state.tiposDePontos.filter((v) => v === 'cre' || v === 'mre').length > 0
            /*this.state.sugerido > 3 || this.state.atual === 4*/
            ? 0.3 : 1}}
        >
        
        <ContainerTheme>
          <SubTitle>Retorno da Refeição</SubTitle>
          <ImageMapa  src={ImgRetornoAlmoco} />
        </ContainerTheme>
        { this.state.sugerido === 3 && this.state.atual !== 4 && this.props.registerPoint.codCliente && this.sugeridoRender() }
      </ContainerRow>
      <ContainerRow 
        sugerido={this.state.sugerido === 4}
        onClick={() => {
          console.log('registro-saida----->', this.state.sugerido, this.state.atual)
          if(
            this.state.tiposDePontos &&
            this.state.tiposDePontos.length > 0 &&
            this.state.tiposDePontos.filter((v) => v === 'cjs' || v === 'mjs').length > 0
          ){
            this.pontoDuplicado('cjs')
          }else{
            this.paraRegisterPoint('1')
          }
          /*if(this.state.atual !== 4){
            this.paraRegisterPoint('1')
          }else{
            this.pontoDuplicado('cjs')
          }*/
        }} 
        style={{ backgroundColor: '#20B2AA', display: 'flex', flexDirection: 'column', 
        opacity: 
          this.state.tiposDePontos &&
          this.state.tiposDePontos.length > 0 &&
          this.state.tiposDePontos.filter((v) => v === 'cjs' || v === 'mjs').length > 0
        /*this.state.sugerido > 4 || this.state.atual === 4*/
        ? 0.3 : 1
      }}
      >
      
      <ContainerTheme>
        <SubTitle>Registro de Saída</SubTitle>
        <ImageMapa marginLeft='-4px' src={ImgSaida} />
      </ContainerTheme>
      { this.state.sugerido === 4 && this.state.atual !== 4 && this.props.registerPoint.codCliente && this.sugeridoRender() }
    </ContainerRow>
      </ContainerCol>
   
        </ContainerContent>
      
        <SubContainerButton>
          <Button width='130px'  backgroundColor='#40bbca' onClick={() => { this.voltar() }} >Voltar</Button>
        </SubContainerButton>

        
          {
            this.state.showModalDuplicado &&
              <ModalAlert 
                noBackgroundBlack={true}
                modalUp={false}
                title={ 'Atenção' } 
                height={'110px'} 
                topText={'30px'}
                message={ this.state.messageModalDuplicado }  
                confirmModal={false}
                onClick={() => { 
                  this.setState({ showModalDuplicado: false })
                  window.location.href = '/home'
                 } }
              />
          }

     </Container>
    )
  }
}


const mapStateToProps = state => ({
  registerPoint: state.registerPoint,
  token: state.token.token,
  configuration: state.configuration,
  home: state.home,
  sagaAtualizarSenha: state.sagaAtualizarSenha.data,
})

const mapDispatchToProps = dispatch => ({
  fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value)),
  pointFlowReset: () => dispatch(pointFlowReset()),
  pointFlowSave: (value) => dispatch(pointFlowSave(value)),
  fetchAtualizarSenhaStart: (mss) => dispatch(fetchAtualizarSenhaStart(mss)),
  atualizarSenhaReset: () => dispatch(atualizarSenhaReset())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PointFlow)